<template>
<div class="content-i">
    <div class="content-box">
        <!--START - Recent Ticket Comments-->
        <div class="element-wrapper">
            <div class="element-actions d-none d-sm-block">
                <a class="btn btn-primary btn-sm">
                    <i class="os-icon os-icon-ui-22"></i>
                    <router-link tag="span" :to="`/copydesk/template/add`">
                        Add Template
                    </router-link>
                </a>
            </div>
            <h6 class="element-header">Copy Desk Templates</h6>
            <Loader v-if="isLoading == false" />
            <div class="element-box-tp" v-else>
                <EmptyState v-if="!pagination.data" >
                    <div slot="empty_state_text">
                       There are no copy desk templates
                    </div>
                </EmptyState>
                <div class="table-responsive" v-else>
                    <table class="table table-padded">
                        <thead>
                            <tr>
                                <th>Template ID</th>
                                <th>Name</th>
                                <th>Channel</th>
                                <th>Category</th>
                                <th>Total Headers</th>
                                <th>Status</th>
                                <th>Last Updated</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="template in pagination.data">
                                <td>TPL{{template.id_copy_template}}</td>
                                <td>{{template.template_name}}</td>
                                <td>{{template.channel_name || 'All Channels'}}</td>
                                <td>{{template.category_name || 'All Categories'}}</td>
                                <td>{{template.total_headers}}</td>
                                <td class="nowrap"> <div v-html="formatTemplateStatus(template)"></div></td>
                                <td><span>{{template.updated_at}}</span></td>
                                <td>
                                    <router-link tag="a" :to="`/copydesk/template/${template.id_copy_template}`">
                                        View
                                    </router-link>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <Pagination v-if="pagination.last_page > 1 " :pagination="pagination" @paginate="getTemplates()" :offset="5"></Pagination>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import Pagination from '@/components/common/Pagination'
import EmptyState from '@/components/common/EmptyState'
import Loader from '@/components/common/Loader'

export default {
  components: {
    Pagination,
    EmptyState,
    Loader
  },
  data: function () {
    return {
      isLoading: true,
      pagination: {
        'current_page': 1
      }
    }
  },
  mounted: function () {
    var self = this
    this.getTemplates()
  },
  methods: {
    getTemplates: function () {
      var self = this
      const url = '/copydesk/templates?page=' + this.pagination.current_page
      let data = {
        page: this.pagination.current_page
      }
      self.isLoading = true
      this.$http.post(url, data, {
        dataType: 'json',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      })
        .then(function (response) {
          self.pagination = response.data.templates
          self.isLoading = true
        })
        .catch(function (error) {
          console.log(error)
          self.isLoading = true
        })
    },
    formatTemplateStatus: function (template) {
      var response = ''
      if (template.is_active == 1) {
        response = '<span class="status-pill smaller green"></span><span>Active</span>'
      } else {
        response = '<span class="status-pill smaller red"></span><span>Inactive</span>'
      }

      return response
    }
  }
}
</script>
